import { render } from "./App.vue?vue&type=template&id=2190d7e4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2190d7e4&scoped=true&lang=css"

import exportComponent from "/Users/alizand/Herd/rodeo/base-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2190d7e4"]])

export default __exports__